<template>
    <span id="hiddenDiv" @click="minimizeAndMaximize">
        <i
            class="fa fa-window-minimize inactive-icon"
            id="minimize"
            aria-hidden="true"
        ></i>
        <i
            class="fa fa-window-maximize active-icon "
            id="maximize"
            aria-hidden="true"
        ></i>
    </span>
</template>

<script>
export default {
    name: 'maximize-and-minimize',
    methods: {
        minimizeAndMaximize() {
            let card = document.querySelector('#hiddenDiv').closest('div')
            let minimize = document.querySelector('#minimize')
            let maximize = document.querySelector('#maximize')

            card.classList.toggle('hidden-card')
            card.classList.toggle('min-and-max')

            if (minimize.classList.contains('active-icon')) {
                minimize.classList.remove('active-icon')
                minimize.classList.add('inactive-icon')
                maximize.classList.remove('inactive-icon')
                maximize.classList.add('active-icon')
            } else {
                maximize.classList.remove('active-icon')
                maximize.classList.add('inactive-icon')
                minimize.classList.remove('inactive-icon')
                minimize.classList.add('active-icon')
            }
        }
    }
}
</script>
